$(function(){
    $('input[required]:not([type=checkbox])').change(function(){
        var field = $(this).closest('.field-wrapper');
        $(this).val().length ? field.addClass('validationPass') : field.addClass('validationFail');
    });
})